import React, {useEffect, useState} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {FolderBreadcrumbItem} from "./FolderBreadcrumbItem";
import {getFolderAncestors} from "../../../../api/pro-guest-functions";
import {run} from "../../../../utils/function-util";

export const FolderHierarchyBreadcrumbs = ({ organizationId, folderId, fullLevel = true }: any) => {
    const [ancestors, setAncestors] = useState([]);
       useEffect(run(getFolderAncestors({ organizationId, folderId, recursive: true }), (items: any) => setAncestors(fullLevel ? items : items.slice(-2))), [organizationId, folderId]);
       return (<Breadcrumbs>
                        {ancestors.map(item => <FolderBreadcrumbItem key={(item as any).id} folder={item} currentId={parseInt(folderId)}/>)}
        </Breadcrumbs>);
};
